angular.module('impactx.basket').directive('approvalSelectionView', function ()
{
    return {
        scope: {
            approver: '=',
            resultEntries: '=',
            trns: '=',
            selectionId: '=',
            showMust: '='
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/approval-selection-view.tmpl.html',
        controller: "ApprovalSelectionViewCtrl",
        controllerAs: 'ctrl'
    };
});